import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { TimeService } from 'src/app/services/time/time.service';
import { environment } from 'src/environments/environment';
import { Guid } from 'guid-typescript';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-mainstreet-batch-upload',
  templateUrl: './mainstreet-batch-upload.component.html',
  styleUrls: ['./mainstreet-batch-upload.component.css']
})
export class MainstreetBatchUploadComponent implements OnInit {

 //batch upload
 batchData: Array<any> = [];
 filteredData: Array<any> = [];
 historicBatches: Array<any> = [];

 //file
 selectedFile: File = null;
 fileName: string = "";
 batchDescription: string = "";
 csvData: Array<string> = [];

 //header
 inputItemsPerPage: number = 10;
 itemsPerPage: number = 10;
 showAll: boolean = true;
 searchString: string = "";
 successCount: number = 0;
 errorCount: number = 0;

 //page
 lambdaError: boolean = false;
 lambdaMessage: string = '';
 username: string = '';
 batchSelect: any = ""
 batchIsSelected: boolean = false;
 disableProcessBatch: boolean = true;
 disableLoadFile: boolean = true;

 currentUser: string = this.auth.currentUser;
 mainstreetTypes: Array<any> = [["MSPP", "mspp"], ["Prime", "prime"], ["Prime and MSPP", "both"]];

 constructor(private telecomService: TelecomService, private auth: AuthService, private timeService: TimeService, private snackbar: MatSnackBar) { }

 ngOnInit() {
   let identity = this.auth.userPool.getCurrentUser().username;
   if (identity.split("_").length === 2) {
     this.username = identity.split('_')[1];
   } else {
     this.username = identity;
   }
   console.log(this.username);
 }

 formatAgentTypeFunction = (type) => {
  if(this.mainstreetTypes.length>0){
    return this.mainstreetTypes.find((typeKey) => {return typeKey[1] == type})[0];
  }
  return type
}

 uploadFile($event) { 
   this.disableLoadFile = false;
   let csv: string = ""
   this.selectedFile = $event.target.files[0];
   this.fileName = this.selectedFile.name;
   console.log('name: ', this.selectedFile.name);
   console.log('size: ', this.selectedFile.size);
   console.log('type: ', this.selectedFile.type);
   let reader: FileReader = new FileReader();
   reader.readAsText(this.selectedFile);
   reader.onload = (e) => {
     console.log('e: ', e);
     csv = reader.result as string;
     let rows = csv.split('\n');
     let newRows = [];
     for (let x = 0; x < rows.length; x++) {
      if(rows[x].endsWith('\r')){
        rows[x] = rows[x].slice(0, -1); //remove \r from windows-ending csvs
      }
      if (rows[x].split(',').join('').trim() == '') {
        rows.splice(x, 1);
        x--;
      }else{
        let row = rows[x];
        let splitRow = row.split(',');
        splitRow.forEach(item => { item = item.trim()});
        console.log(splitRow)
        newRows.push(splitRow)
      }
    }
    if (rows[rows.length - 1] === "") {
      rows.pop();
    }
     console.log('rows: ', newRows);
     this.csvData = newRows;
     this.batchDescription = "";
     this.submitCsvData();
   }
 }

 // processes csv
 submitCsvData() { 
   this.lambdaError = false;
   this.lambdaMessage = '';
   this.batchData = [];
   let now = new Date();
   let createdDate = this.timeService.getDateTimeString(now);

   for(let x = 0; x < this.csvData.length; x++){
      let dictRow = {};

      //build dictionary from list
        dictRow['ani'] = this.formatPhoneNumber(this.csvData[x][0]);
        dictRow['agentName'] = this.csvData[x][1] ? this.csvData[x][1] : "";
        dictRow['agentEmail'] = this.csvData[x][2] ? this.csvData[x][2] : "";
        dictRow['agentType'] = this.csvData[x][3];
      //housekeeping stuff
      dictRow['creator'] = this.currentUser;
      dictRow['createdDate'] = createdDate;
      dictRow['updatedBy'] = this.currentUser;
      dictRow['updatedDate'] = createdDate;
      dictRow['id'] = this.GUID();
      dictRow['aniType'] = 'MSPP';

      this.batchData.push(dictRow);
   }
   this.applyFilter()
   this.disableProcessBatch = false;
 }

 // put all the rows displayed in the DDB
 processBatch() {
   this.lambdaError = false;
   this.lambdaMessage = '';
   this.disableProcessBatch = true;
   let params = {
     FunctionName: environment.ANIConfigLambdaName,
     Payload: JSON.stringify({ 
        operation: "batchUpload",
        data: this.batchData 
      })
   };
   this.telecomService.callLambda(params, "An error occurred while processing ANI batch").then((response: any) => {
     this.disableProcessBatch = false;
     if (response.statusCode != 200) {
       this.lambdaError = true;
       this.lambdaMessage = "An error occurred while processing ANI batch"
       this.snackbar.open(this.lambdaMessage, "Ok", {verticalPosition: 'bottom'});
     }else{
      this.snackbar.open("Data uploaded successfully.", "Ok", {verticalPosition: 'bottom'});
      this.cancelSelectedBatch();
     }
   },
     err => {
       this.lambdaError = true;
       this.lambdaMessage = "An error occurred while processing ANI batch"
       this.snackbar.open(`Error: ${err}`, "Ok", {verticalPosition: 'bottom'});
     });
 }

 applyFilter() { // what does this do?
   let temp = []
   let search = this.searchString.toLowerCase();
   this.batchData.map(x => {
     if (x.agentName.toLowerCase().includes(search) ||
       x.ani.toLowerCase().includes(search) ||
       x.agentType.toLowerCase().includes(search)
     ) {
       if (this.showAll) {
         temp.push(x);
       } else if (x.status != 'success') {
         temp.push(x);
       }
     }
   });
   this.filteredData = JSON.parse(JSON.stringify(temp));
 }

 statusCount() {
   this.successCount = 0;
   this.errorCount = 0;
   this.batchData.map(x => {
     if (x.status == 'success') {
       this.successCount++;
     } else if (x.status == 'failed') {
       this.errorCount++;
     }
   });
   if (this.errorCount > 0) {
     this.lambdaError = true;
     this.lambdaMessage = "Errors in batch. Review table for details."
   }
 }

 cancelSelectedBatch() {
   this.batchData = [];
   this.applyFilter();
   this.disableProcessBatch = true;
 }

 enforceMaxNumber() {
   if (this.itemsPerPage == null) {
     this.inputItemsPerPage = 1;
   } else {
     if (this.itemsPerPage > 200) {
       this.itemsPerPage = 200;
     } else if (this.itemsPerPage < 1) {
       this.itemsPerPage = 1
     }
     this.inputItemsPerPage = this.itemsPerPage;
   }
 }

 formatPhoneNumber(phoneNumber){
  let formattedNumber = phoneNumber;
  let formattingRegex = /^(\+?\d{1,2})?\s?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})$/;
  let matches = formattingRegex.exec(phoneNumber);
  if (matches && matches.length >= 4){
    if(matches[1]){
      formattedNumber = `${matches[1]}${matches[2]}${matches[3]}${matches[4]}`;
    }
    else{
      formattedNumber = `+1${matches[2]}${matches[3]}${matches[4]}`;
    }
  }
  return formattedNumber
}

 cleanField() {
   if (this.itemsPerPage == null) {
     this.itemsPerPage = 1;
   }
   this.enforceMaxNumber();
 }

 GUID(){
  return Guid.create()['value'];
  }
}
